<template>
  <div>
    <h4>Remboursement des dépenses</h4>
    <div class="d-flex flex-wrap">

      <table class="table table-bordered table-compact mr-2" style="width: auto">
        <tbody>
          <tr>
            <td class="text-right">{{ kmTotal }} km x {{ kmRate }} $/km:</td>
            <td class="text-right">{{ formatMoney(kmTotal*kmRate) }}</td>
          </tr>
          <tr>
            <td class="text-right">Dépenses:</td>
            <td class="text-right">{{ formatMoney(expensesAmountWithoutTax) }}</td>
          </tr>
        </tbody>
      </table>

      <table class="table table-bordered table-compact" style="width: auto">
        <tbody>
          <tr>
            <td class="text-center">S-Total</td>
            <td class="text-center">TPS</td>
            <td class="text-center">TVQ</td>
            <td class="text-center bold">Total</td>
          </tr>
          <tr>
            <td class="text-right">{{formatMoney(subTotal)}}</td>
            <td class="text-right">{{formatMoney(totalTaxes.tps)}}</td>
            <td class="text-right">{{formatMoney(totalTaxes.tvq)}}</td>
            <td class="text-right">{{formatMoney(subTotal+totalTaxes.tps+totalTaxes.tvq)}}</td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>
</template>

<script>
  export default {
    name: "timesheet-expense-totals",
    props: {
      tps: {
        type: Number,
        default: 0
      },
      tvq: {
        type: Number,
        default: 0
      },
      kmRate: {
        type: Number,
        default: 0
      },
      rows: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      kmTotal() {
        let total = 0;
        for (const row of this.rows) {
          if(row.timesheet_entry_type == "3") {
            for (const date in row.days) {
              if(["deleted", null].indexOf(row.days[date].timesheet_entry_value) === -1){
                total += parseFloat(row.days[date].timesheet_entry_value);
              }
            }
          }
        }
        return total;
      },
      subTotal() {
        return this.expensesAmountWithoutTax + this.kmTotal * this.kmRate;
      },
      expensesAmountWithTax() { // Total avec taxes des dépenses.
        let total = 0;
        for (const row of this.rows) {
          if(row.timesheet_entry_type == "2") {
            for (const date in row.days) {
              if(["deleted", null].indexOf(row.days[date].timesheet_entry_value) === -1){
                total += parseFloat(row.days[date].timesheet_entry_value);
              }
            }
          }
        }
        return total;
      },
      totalExpenseTaxes() {
        let expensesWithTax = this.expensesAmountWithTax;
        let expensesWithoutTax = expensesWithTax / ((this.tvq + this.tps) / 100 + 1);
        let taxe_total = expensesWithTax - expensesWithoutTax;

        let tvq_total = expensesWithoutTax * (this.tvq / 100);
        let tps_total = taxe_total - tvq_total;
        
        return {
          tps: tps_total,
          tvq: tvq_total,
          total: taxe_total,
        }
      },
      expensesAmountWithoutTax() { // Total sans taxes des dépenses.
        return this.expensesAmountWithTax - this.totalExpenseTaxes.total;
      },
      totalTaxes() {
        let subTotal = this.subTotal;
        let kmTotal = this.kmTotal * this.kmRate;
        let tps_total = (kmTotal * (this.tps / 100)) + this.totalExpenseTaxes.tps;
        let tvq_total = (kmTotal * (this.tvq / 100)) + this.totalExpenseTaxes.tvq;
        
        return {
          tps: parseFloat(tps_total),
          tvq: parseFloat(tvq_total),
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>